module.exports = __webpack_public_path__ + "img/gestionLignesCVC.784ed236.jpg";